import {createSlice, PayloadAction} from '@reduxjs/toolkit';

import type {RootState} from './store/ChatAppStore';

interface ChatState {
  hiddenChats: string[];
}

const initialState: ChatState = {hiddenChats: []};

function setHidden(state: ChatState, url: string, isCurrentlyHidden: boolean) {
  const i = state.hiddenChats.indexOf(url);
  if (isCurrentlyHidden) {
    if (i === -1) state.hiddenChats.push(url);
  } else {
    if (i !== -1) state.hiddenChats.splice(i, 1);
  }
}

export const chatSlice = createSlice({
  name: 'aichat',
  initialState,
  reducers: {
    toggleChat: (state, action: PayloadAction<{url: string}>) => {
      const {url} = action.payload;
      setHidden(state, url, !state.hiddenChats.includes(url));
    },

    setChatHidden: (state, action: PayloadAction<{url: string}>) => {
      setHidden(state, action.payload.url, true);
    },
  },
});

export const selectIsHidingChat = (state: RootState, url: string): boolean =>
  state.aichat.hiddenChats.includes(url);

export const {toggleChat, setChatHidden} = chatSlice.actions;

export default chatSlice.reducer;
